import { MAX_RESULTS, } from "@gigsync/protocol";
import { pluralKey } from "../i18n/t.js";
import { rateHint, rateNote } from "../interview/card-rates.js";
import { estimateLines } from "../interview/estimate-lines.js";
import { CITY_RATES } from "../job/city-rates.js";
import { CITY_AREA } from "../landing/cities.js";
import { log } from "../log.js";
/** The card's city is the move's: another city's band is never shown as this one's. */
const cardFor = (rates, city) => city !== undefined && rates.city.toLowerCase() === city ? rates : undefined;
/** One trade's figures: the estimate's lines, else the band's, else that there are none there. */
function tradeLines(i, trade, card) {
    const found = i.estimates[trade];
    if (found)
        return { lines: estimateLines(i.own, found), band: false };
    if (card)
        return { lines: rateHint(card, trade), band: true };
    return { lines: [{ key: "moving.no_figures", names: { trade: [`trade.${trade}`] } }], band: false };
}
/** How many workers of the trade the board has in the city; "or more" when the board's page was full. */
function listedLine(i, trade) {
    const count = i.listed[trade];
    if (count === undefined || i.city === undefined)
        return [];
    const names = { trade: [`trade.${trade}`], city: [`city.${i.city}`] };
    if (count >= MAX_RESULTS)
        return [{ key: "moving.listed_many", names, params: { count } }];
    return [{ key: pluralKey(i.own, "moving.listed", count), names, params: { count } }];
}
/** The outlook's lines in order, trade by trade, then the notes; "no figures" alone when there is no city. */
export function workOutlook(i) {
    if (i.city === undefined)
        return { lines: [{ key: "moving.no_outlook" }] };
    const card = cardFor(i.rates ?? CITY_RATES, i.city);
    const each = i.trades.map((trade) => ({ trade, ...tradeLines(i, trade, card) }));
    const banded = each.filter((e) => e.band).map((e) => e.trade);
    const lines = [
        ...each.flatMap((e) => [...e.lines, ...listedLine(i, e.trade)]),
        ...(card ? rateNote(card, banded) : []),
        { key: "moving.estimates" },
    ];
    return { lines };
}
/**
 * Workers of a trade with a card on the board in the city with a guide, not counting the owner: one search across the
 * city's area, at most a page of `MAX_RESULTS`. Undefined when the board cannot be reached; the outlook goes without it.
 */
export async function countListed(search, city, trade, me) {
    const { centre, radius_km } = CITY_AREA[city];
    try {
        const found = await search({ trade, lat: centre.lat, lon: centre.lon, radius_km, limit: MAX_RESULTS });
        // A full page may hold the owner too: it still says "or more".
        return found.length >= MAX_RESULTS ? MAX_RESULTS : found.filter((w) => w.user !== me).length;
    }
    catch (err) {
        log.warn("board count failed", { trade, error: err instanceof Error ? err.name : String(err) });
        return undefined;
    }
}
//# sourceMappingURL=outlook.js.map